import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["classes", "children", "label", "className", "style", "hint", "icon", "variant", "inputComponent", "errorMessage", "value", "ref", "theme", "tooltip", "onFocus", "selectOnFocus"];

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import withTheme from '../theme/withTheme';
import { InputBaseWrapper, InputBaseContainer, LabelText, HelperText, Input, Icon } from './styles';
import Tooltip from '../Tooltip';
var keys = ['theInput', 'element'];

var isNullOrEmpty = function isNullOrEmpty(str) {
  var strArg = str === null ? str : String(str);
  return typeof strArg === 'undefined' || strArg === null || /\S/.test(strArg) === false || Object.keys(strArg).length === 0;
};

var getInputValue = function getInputValue(ref) {
  if (!ref || !ref.current) return null;
  /**
   * The react-currency-input has a 'theInput' prop instead of 'element'.
   * Because it is a base input, it should handle all type of refs
   */

  var elementKey = Object.keys(ref.current).find(function (k) {
    return keys.includes(k);
  });
  return ref.current[elementKey].value;
};

var InputBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(InputBase, _React$PureComponent);

  var _super = _createSuper(InputBase);

  function InputBase(props) {
    var _this;

    _classCallCheck(this, InputBase);

    _this = _super.call(this, props);
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.onFocusHandler = _this.onFocusHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.forceUpdate();
      });
    }
  }, {
    key: "onFocusHandler",
    value: function onFocusHandler(event) {
      event.preventDefault();
      event.persist();
      var _this$props = this.props,
          onFocus = _this$props.onFocus,
          selectOnFocus = _this$props.selectOnFocus;

      if (selectOnFocus) {
        var target = event.target;
        var charCount = target.value.length;
        target.setSelectionRange(0, charCount);
      }

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          children = _this$props2.children,
          label = _this$props2.label,
          className = _this$props2.className,
          style = _this$props2.style,
          hint = _this$props2.hint,
          icon = _this$props2.icon,
          variant = _this$props2.variant,
          inputComponent = _this$props2.inputComponent,
          errorMessage = _this$props2.errorMessage,
          value = _this$props2.value,
          ref = _this$props2.ref,
          theme = _this$props2.theme,
          tooltip = _this$props2.tooltip,
          onFocus = _this$props2.onFocus,
          selectOnFocus = _this$props2.selectOnFocus,
          rest = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement(InputBaseWrapper, {
        theme: theme,
        className: clsx(className, classes.wrapper),
        style: style
      }, tooltip && /*#__PURE__*/React.createElement(Tooltip, tooltip), /*#__PURE__*/React.createElement(InputBaseContainer, {
        theme: theme,
        variant: variant,
        className: clsx(classes.container)
      }, label && /*#__PURE__*/React.createElement(LabelText, {
        theme: theme,
        variant: variant,
        className: clsx(classes.label),
        inputHasValue: !isNullOrEmpty(value || getInputValue(ref || this.inputRef))
      }, label), icon && /*#__PURE__*/React.createElement(Icon, {
        theme: theme,
        className: clsx(classes.icon),
        component: icon()
      }), children || /*#__PURE__*/React.createElement(Input, _extends({
        theme: theme,
        component: inputComponent,
        className: clsx(classes.input),
        value: value,
        onFocus: this.onFocusHandler
      }, rest))), (hint || errorMessage && variant === 'error') && /*#__PURE__*/React.createElement(HelperText, {
        theme: theme,
        className: clsx(classes.helper),
        variant: variant
      }, variant === 'error' ? errorMessage || hint : hint));
    }
  }]);

  return InputBase;
}(React.PureComponent);

InputBase.defaultProps = {
  icon: null,
  variant: 'default',
  children: null,
  inputComponent: function inputComponent() {},
  classes: {
    wrapper: '',
    container: '',
    label: '',
    icon: '',
    input: '',
    helper: ''
  }
};
process.env.NODE_ENV !== "production" ? InputBase.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func]),
  variant: PropTypes.oneOf(['default', 'success', 'error']),
  children: PropTypes.node,
  inputComponent: function inputComponent(props, propName) {
    if (props.children === false && props[propName] === undefined) {
      return new Error('The prop `inputComponent` is required');
    }
  },
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    container: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    input: PropTypes.string,
    helper: PropTypes.string
  })
} : void 0;
var RefInputBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InputBase, _extends({}, props, {
    ref: ref
  }));
});
export default withTheme(RefInputBase);